export default __webpack_public_path__ + "static/media/notFound.acd11c1f.png";